import axios from 'axios';
import INotification from '../components/NotificationComponent/INotification';
import ICompanyReducer from '../interfaces/ICompanyReducer';
import { createAction } from 'typesafe-actions';
import {
  ADD_NOTIFICATION,
  ALL_DATA_SAVED,
  GET_COMPANY_INFO,
  GET_COMPANY_INVESTORS,
  GET_COMPANY_MEMBERS,
  GET_COMPANY_TOP_INVESTORS,
  GET_DOCUMENTS_INFO,
  GET_FUNDING_DATA,
  REMOVE_NOTIFICATION,
  RESET_LOCAL_STATE,
  RESTORE_LOCAL_STATE,
  SAVE_ALL_DATA,
  SET_FORM_DIRTY,
  SET_IS_SAVING,
  UPDATE_COMPANY_FOLLOWERS,
  UPDATE_COMPONENTS_COUNTER,
  UPDATE_VALIDATION_COUNTER,
} from './actionTypes';
import { compareDates, parseValidationError } from '@features/utils/functions';
import NotificationTypes from '../enums/NotificationTypes';
import BttfAxios from '@features/utils/axios';

export const addNotification = createAction(ADD_NOTIFICATION, (notification: INotification) => ({
  type: ADD_NOTIFICATION, payload: notification,
}));

export const removeNotification = createAction(REMOVE_NOTIFICATION, (index: number) => ({
  type: REMOVE_NOTIFICATION, payload: index,
}));

let tempComponentCounter = 0;
export const saveAllDataAction = (data: {}, name: string) => {
  return (dispatch:Function, getState: Function) => {
    dispatch({
      name,
      type: SAVE_ALL_DATA,
      payload: data,
    });
    tempComponentCounter += 1;
    if (tempComponentCounter === getState().companyReducer.componentCounter) {
      let whitepaperId = null;
      const state:ICompanyReducer = getState();
      const socials:any = {};
      const investmentRounds:any = [];
      const investors:any = [];
      const members:any = [];
      const documents: any = [];

      state.companyReducer.companyDetails.social_media.forEach((elem: any) => {
        socials[Object.keys(elem)[0]] = Object.values(elem)[0];
      });

      state.companyReducer.funding.forEach((elem: any) => {
        const _elem = { ...elem };

        if (typeof elem.id === 'string' && elem.id.substring(0, 3) === 'NEW') {
          _elem.id = null;
          investmentRounds.push(_elem);
        } else if (elem.website !== undefined) {
          investmentRounds.push(_elem);
        }
      });

      Object.values(state.companyReducer.companyInvestors).forEach((elem: any) => {
        const _elem = {  ...elem };
        if (_elem.imageId) {
          _elem.avatar_id = _elem.imageId;
          delete _elem.imageId;
        }

        if (!_elem.editable && !_elem._destroy && _elem.newSearchInvestor) {
          const searchInvestor = { investor_id: _elem.id };
          investors.push(searchInvestor);
          return;
        }
        investors.push(_elem);
      });

      Object.values(state.companyReducer.companyMembers).forEach((elem: any) => {
        const _elem = {  ...elem };
        if (_elem.imageId) {
          _elem.avatar_id = _elem.imageId;
          delete _elem.imageId;
        }
        _elem.full_name = _elem.name;
        delete _elem.name;

        members.push(_elem);
      });

      state.companyReducer.documents.forEach((elem: any) => {
        if (elem.type === 'whitepaper' && !elem._destroy) {
          whitepaperId = elem.id;
        } else if (elem.type === 'other' && !elem._destroy) {
          documents.push(elem.id);
        }
      });

      const fundingToDate = state.companyReducer.companyDetails.funding_to_date;

      // delete company avatar
      // we need to catch when removing unsaved but uploaded image
      if (state.companyReducer.companyDetails.avatar.to_delete_id) {
        axios.delete(`/api/images/${state.companyReducer.companyDetails.avatar.to_delete_id}`).catch((e) => {});
      }

      const postData = {
        name: state.companyReducer.companyDetails.name,
        legal_name: state.companyReducer.companyDetails.legal_name,
        description: state.companyReducer.companyDetails.description,
        founded_at: new Date(`${state.companyReducer.companyDetails.founded}`),
        website: state.companyReducer.companyDetails.website,
        facebook_page: socials.facebook ? socials.facebook : null,
        linkedin_page: socials.linkedin ? socials.linkedin : null,
        twitter_id: socials.twitter ? socials.twitter : null,
        telegram_page: socials.telegram ? socials.telegram : null,
        github_page: socials.github ? socials.github : null,
        labels: state.companyReducer.companyDetails.labels[0],
        avatar_id: state.companyReducer.companyDetails.avatar.id,
        cover_photo_id: state.companyReducer.cover_photo.id,
        whitepaper_id: whitepaperId,
        document_ids: documents,
        funding_to_date: fundingToDate,
        markets: state.companyReducer.companyDetails.markets,
        address: state.companyReducer.companyDetails.location,
        investment_rounds: investmentRounds,
        company_investors: investors,
        company_members: members,
      };

      BttfAxios.put(`/api/companies/${state.companyReducer.companyDetails.id}`, postData, (res) => {
        const _res = res.data;
        tempComponentCounter = 0;

        _res.investment_rounds = [...getState().companyReducer.funding, ..._res.investment_rounds]
        .filter((val, index, self) => self.findIndex(e => (e.id === val.id)) === index && typeof val.id !== 'string')
        .sort(compareDates)
        .map((el) => { return { ...el, date: el.date.slice(0, 10) }; });

        dispatch({
          type: ALL_DATA_SAVED,
          payload: _res,
        });

        const notification: INotification = {
          message: 'Changes have been Saved',
          type: NotificationTypes.info,
          created_at: new Date(),
        };
        dispatch(addNotification(notification));
      }, (error, next) => {
        const errorNotification:INotification = {
          message: parseValidationError(error.response.data),
          type: NotificationTypes.formError,
          created_at: new Date(),
          actions: [{
            label: 'Close',
            callback: (index) => {
              dispatch(removeNotification(index));
            },
          }],
        };

        if (error.response.status === 422) {
          tempComponentCounter = 0;
          dispatch(addNotification(errorNotification));
        } else {
          next();
        }
      });
    }
  };
};

export const setIsSaving = () => {
  return {
    type: SET_IS_SAVING,
  };
};

export const setFormDirty = (data: boolean) => {
  return {
    type: SET_FORM_DIRTY,
    payload: data,
  };
};

export const updateComponentsCounter = (value: number) => {
  return {
    type: UPDATE_COMPONENTS_COUNTER,
    payload: value,
  };
};

export const updateValidationCounter = (data: number) => {
  return {
    type: UPDATE_VALIDATION_COUNTER,
    payload: data,
  };
};

export const getInvestorsInfo = (id: string) => {
  return (dispatch: Function): object => {
    return BttfAxios.all([
      axios.get(`/api/companies/${id}/investors`),
      axios.get(`/api/companies/${id}/company_investors`),
    ], (investors, companyInvestors) => {
      dispatch({
        type: GET_COMPANY_INVESTORS,
        payload: companyInvestors.data,
      });

      dispatch({
        type: GET_COMPANY_TOP_INVESTORS,
        payload: investors.data,
      });
    });
  };
};

export const getMembersInfo = (id: string) => {
  return (dispatch: Function): object => {
    return BttfAxios.get(`/api/companies/${id}/team_members`, (res) => {
      dispatch({
        type: GET_COMPANY_MEMBERS,
        payload: res.data,
      });
    });
  };
};

export const getCompanyInfo = (id: string) => {
  return (dispatch: Function): object  => {
    return BttfAxios.get(`/api/companies/${id}`, (res) => {
      dispatch({
        type: GET_COMPANY_INFO,
        payload: res.data,
      });

      return res.data;
    },
    (error, next) => {
      next();
    });
  };
};

export const getDocuments = (id: string) => {
  return (dispatch: Function): object  => {
    return BttfAxios.get(`/api/companies/${id}/documents`, (res) => {
      dispatch({
        type: GET_DOCUMENTS_INFO,
        payload: res.data,
      });
    });
  };
};

export const getFunding = (id: string) => {
  return (dispatch: Function): object  => {
    return BttfAxios.all([
      axios.get(`/api/companies/${id}/investment_rounds`),
      axios.get(`/api/companies/${id}/pitches`),
    ], (investrounds, pitches) => {
      const response = [...investrounds.data, ...pitches.data];
      response.sort(compareDates).forEach((el) => {
        el.date = el.date.slice(0, 10);
      });

      dispatch({
        type: GET_FUNDING_DATA,
        payload: response,
      });
    });
  };
};


export const resetStore = () => {
  return {
    type: RESET_LOCAL_STATE,
  };
};

export const restoreStore = () => {
  return {
    type: RESTORE_LOCAL_STATE,
  };
};

export const getAllCompanyData = (slug: string) => {
  return (dispatch: Function): Promise<object> => Promise.all([
    dispatch(getCompanyInfo(slug)),
    dispatch(getInvestorsInfo(slug)),
    dispatch(getMembersInfo(slug)),
    dispatch(getDocuments(slug)),
    dispatch(getFunding(slug)),
  ]);
};

export const updateCompanyFollowers = (followers: number) => ({
  type: UPDATE_COMPANY_FOLLOWERS,
  payload: followers,
});
